import { ProductFeatureProcessingTimesModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class ProcessingTime extends DomainEntity<ProductFeatureProcessingTimesModelDto> {
    public static from(dto: ProductFeatureProcessingTimesModelDto): ProcessingTime {
        return new ProcessingTime(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id() {
        return this.dto.id;
    }

    public get name() {
        return this.dto.name ?? '';
    }

    public get startTime() {
        return this.dto.startTime ?? '';
    }

    public set startTime(value: string) {
        this.dto.startTime = value;
    }

    public get cutOffTime() {
        return this.dto.cutOffTime ?? '';
    }

    public set cutOffTime(value: string) {
        this.dto.cutOffTime = value;
    }

    public get nextBusinessDay() {
        return this.dto.nextBusinessDay ?? false;
    }

    public set nextBusinessDay(value: boolean) {
        this.dto.nextBusinessDay = value;
    }

    public get showNextBusinessDay() {
        return this.dto.showNextBusinessDay ?? false;
    }

    public get startTimeNotApplicable() {
        return this.dto.startTimeNotApplicable ?? false;
    }

    public get showInChannel() {
        return this.dto.showInChannel ?? false;
    }

    public set showInChannel(value: boolean) {
        this.dto.showInChannel = value;
    }
}
